import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { LocaleGate } from "@/i18n/LocaleContext";
import { lazy, Suspense } from "react";
import FearGreedButton from "./components/FearGreedButton";

const Layout = lazy(() => import("./components/Layout"));
const EmbedButton = lazy(() => import("./pages/EmbedButton"));
const About = lazy(() => import("./pages/About"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Support = lazy(() => import("./pages/Support"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={null}>
            <Routes>
              {/* English (default — no prefix) */}
              <Route element={<LocaleGate />}>
                <Route index element={<FearGreedButton />} />
                <Route path="app" element={<Navigate to="/" replace />} />
                <Route element={<Layout />}>
                  <Route path="about" element={<About />} />
                  <Route path="privacy" element={<Privacy />} />
                  <Route path="support" element={<Support />} />
                </Route>
              </Route>

              {/* Localized routes: /:locale */}
              <Route path=":locale" element={<LocaleGate />}>
                <Route index element={<FearGreedButton />} />
                <Route element={<Layout />}>
                  <Route path="about" element={<About />} />
                  <Route path="privacy" element={<Privacy />} />
                  <Route path="support" element={<Support />} />
                </Route>
              </Route>

              {/* Embed (no locale) */}
              <Route path="embed/button" element={<EmbedButton />} />

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
